import { mapGetters, mapActions, mapState } from "vuex";
import UnlinkIcon from "@/components/icons/UnlinkIcon.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import AppIcon from "@/components/AppIcon";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import AppModal from "@/components/AppModal";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { country_codes, country_codes_flipped } from "@/utils/countries";
export default {
  name: "AdvertisingAccountWithFlag",
  components: {
    UnlinkIcon,
    WrapWithPopover,
    AppIcon,
    WrapWithCopy,
    AppModal
  },
  emits: ["reauthenticate-account", "refresh"],
  mixins: [TasksMixin],
  props: {
    profile: Object
  },
  data() {
    return {
      isHovered: false,
      showPopOver: false,
      accountDeleteModal: false,
      removeLoading: false,
      accountRemoveTaskIdentifier: "",
      country_codes_flipped
    };
  },
  computed: {
    ...mapGetters(["getCountryFlag"]),
    ...mapState({
      me: state => state.auth.me,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      isClientAdmin: state => state.auth.isClientAdmin,
      isClientUser: state => state.auth.isClientUser,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace
    }),
    isAdsAccount() {
      return this.profile.account_provider == "Amazon Advertising";
    },
    statusState() {
      return this.profile.credential_status ?? "active";
    },
    advertiserNameOrCountry() {
      return !this.isAdsAccount ? this.profile.advertiser_name : this.getProfileCountryCode() === "UK" || this.getProfileCountryCode() === "GB" ? "UK" : country_codes_flipped[this.getProfileCountryCode()];
    }
  },
  mounted() {
    this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.profile.account_id + "_" + "accounts_delete";
    this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
    this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
  },
  methods: {
    ...mapActions(["accountRemove"]),
    getProfileCountryCode() {
      return this.profile.countryCode ?? this.profile.country;
    },
    onAccountReAuthenticate() {
      this.$emit("reauthenticate-account");
    },
    onMouseEnter() {
      this.isHovered = true;
    },
    onMouseLeave() {
      this.isHovered = false;
      this.showPopOver = false;
    },
    onClickCountryCode() {
      //console.log("onClickCountryCode clicked")
      this.showPopOver = true;
    },
    onAccountDelete() {
      //console.log("onAccountDelete clicked")
      this.isHovered = false;
      this.showPopOver = false;
      this.accountDeleteModal = true;
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning(data) {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(data?.task_id);
    },
    handleFinished(data) {
      this.removeLoading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: data.task_status + ": " + data.task_result.status,
        delay: 60 // Show alert less than 1 minute
      });
    },
    async onAccountDeleteConfirm() {
      //console.log("onAccountDeleteConfirm clicked")
      this.accountDeleteModal = false;
      this.removeLoading = true;
      let account_remove_task = await this.accountRemove({
        seller_list: [{
          account_id: this.profile.account_id.toString()
        }],
        task_identifier_omny: this.accountRemoveTaskIdentifier,
        workspace_id: this.current_workspace.workspace_id.toString()
      });
      this.getAsyncUpdate(account_remove_task.task_id);
      this.checkTaskStatusPeriodically(account_remove_task.task_id);
      //await this.accountRemove(payload);
    }
  }
};